import React, { useEffect, useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { ArticleCard } from "@/components/ArticleCard";
import { usePersonalization, orderResources } from "@/lib/personalization";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const K = { fontFamily: "Kanit, Arial, sans-serif" };
const S = { fontFamily: "'Noto Serif', Georgia, serif" };

// Three curated articles on the Home, ordered for the active route. Links to the full Resources page.
export default function HomeResources() {
  const [posts, setPosts] = useState([]);
  const { profile, need } = usePersonalization();

  useEffect(() => {
    axios.get(`${API}/posts`).then((r) => setPosts(Array.isArray(r.data) ? r.data : [])).catch(() => setPosts([]));
  }, []);

  const picks = orderResources(posts, { profile, need }).slice(0, 3);
  if (!picks.length) return null;

  return (
    <section id="resources" data-testid="home-resources-section" data-route={profile || "neutral"} className="bg-[#F5EFE7] text-[#451C25] py-24 md:py-32 px-6 md:px-10 lg:px-14 border-t border-[#451C25]/10">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6">
          <div className="max-w-2xl">
            <p className="text-[#897756] text-[11px] tracking-[0.3em] uppercase mb-6 font-semibold" style={K}>Resources</p>
            <h2 data-testid="home-resources-headline" className="text-4xl md:text-5xl leading-[1.05] tracking-tight" style={{ ...K, fontWeight: 600 }}>Resources for the road ahead</h2>
            <p className="mt-6 text-[#6B4954] text-base md:text-lg leading-relaxed" style={S}>Practical reading on the questions that come up on the way to Spain, chosen for the path you've selected.</p>
          </div>
          <Link to="/resources" data-testid="home-resources-all" className="group inline-flex items-center gap-2 text-[12px] tracking-[0.18em] uppercase font-semibold text-[#451C25] border-b border-[#B3A17D] pb-1 hover:text-[#6B4954] transition-colors shrink-0" style={K}>
            All resources <ArrowRight size={14} className="transition-transform group-hover:translate-x-1" />
          </Link>
        </div>
        <ul data-testid="home-resources-grid" className="mt-12 md:mt-14 grid grid-cols-1 md:grid-cols-3 gap-x-8 gap-y-12">
          {picks.map((p, i) => (
            <li key={p.slug}><ArticleCard post={p} eager={false} testId={`home-resource-${i + 1}`} /></li>
          ))}
        </ul>
      </div>
    </section>
  );
}
